import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { persist: { type: Boolean, default: false } };

  connect() {
    if (!this.persistValue) {
      this.timeout = setTimeout(() => this.dismiss(), 5000);
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  dismiss() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.element.remove();
  }
}
